<template>
    <el-dialog v-dialogDrag  class="dialog" width="500px" :visible.sync="dialogVisible" v-loading="dialoading"
               :close-on-click-modal="false"
               top="30vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                编辑提成比例
            </div>
        </div>
        <div class="dialog_body">
            <el-form :model="form" ref="formData" v-loading="loading"  label-width="120px"
                     style="padding: 15px;padding-top: 10px">
                <el-form-item label="业务员" prop="salesMan">
                    <el-input type="text" v-model="form.salesMan" placeholder="请选择业务员，未选择则适用于所有人"
                              @click.native="selStaff" clearable></el-input>
                </el-form-item>
                <el-form-item label="最小金额" prop="minTotal">
                    <el-input type="number" v-model="form.minTotal" placeholder="请输入最小金额"></el-input>
                </el-form-item>
                <el-form-item label="最大金额" prop="maxTotal">
                    <el-input type="number" v-model="form.maxTotal" placeholder="请输入最大金额"></el-input>
                </el-form-item>
                <el-form-item label="提成比例" prop="commissionRate">
                    <el-input type="number" v-model="form.commissionRate" placeholder="请输入提成比例">
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>
            </el-form>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="danger" @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>
        <selStaff v-if="showStaff"
                  :staffId="staffId"
                  @closeDialog="closeDialog"
                  @checkRow="checkStaff">
        </selStaff>
    </el-dialog>
</template>

<script>

    import selStaff from '@/components/rszy/staff/selStaff'
    export default {
        name: "editDialog",
        components: {
            selStaff
        },
        props: ['formData', 'loading'],
        data() {
            return {
                dialoading: this.loading,
                form: JSON.parse(JSON.stringify(this.formData)),
                dialogVisible: true,
                formLabelWidth: '80px',
                staffId:"",
                salesMan:"",
                showStaff:false,
            };
        },
        mounted() {
        },
        methods: {
            closeDialog() {
                this.showStaff = false;
            },
            selStaff() {
                this.showStaff = true;
            },
            checkStaff(row) {
                this.staffId = row.staffId;
                this.form.salesMan = row.staffName;
                this.showStaff = false;
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
            submitForm() {
                if(this.form.minTotal==null || this.form.minTotal==''){
                    this.$message({message: '请输入最小金额', type: 'error'});
                    return false;
                }
                if(this.form.maxTotal==null || this.form.maxTotal==''){
                    this.$message({message: '请输入最大金额', type: 'error'});
                    return false;
                }
                if(parseFloat(this.form.maxTotal)<parseFloat(this.form.minTotal)){
                    this.$message({message: '最大金额不能小于最小金额', type: 'error'});
                    return false;
                }
                if(this.form.commissionRate==null || this.form.commissionRate==''){
                    this.$message({message: '请输入提成比例', type: 'error'});
                    return false;
                }
                this.$emit('submitForm', this.form)
            },
        }
    }
</script>

